// src/config/logger.ts
import { logger } from '@myorg/type-lib';

export function initializeLogger() {
  logger.init(import.meta.env.VITE_DEBUG);
  logger.log("6.23 4:05 Env:", import.meta.env.VITE_ENV);
}

export { logger };
